import ajax from '../lib/ajax';
export const uploadImageFile = (data)=>{
    return ajax({
        url: '/api/static/file',
        method: 'post',
        data: data
    }).then(res=>{
        return res.result;
    });
}